module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-performance-1269baa9a194f2c4ec7d44e026db04a5.svg";